module.exports = __webpack_public_path__ + "static/leadership-9a2fcc448628e7919a6ca5619504cab0.png";